import api from "./api";
import toast from "./toast";
import database from "./database";

export default {
  prev_user_id: 0,
  prev_account: 0,
  toast: null,
  version: "2.0",
  badge_timer: null,
  update_timer: null,
  reset_can_scan: function(){
    this.prev_user_id = 0;
    this.prev_account = 0;
  },
  check_can_scan: function(user){
    if (user.id == this.prev_user_id && user.account ==  this.prev_account) {
      return false;
    }

    this.prev_user_id = user.id;
    this.prev_account = user.account;

    return true;
  },
  checkUpdate: function () {
      api.getVersion().then(data => {
        if (data.version && data.version != this.version) {
          if (this.toast == null) {
            this.toast = toast.create({
              text: 'Er is een update beschikbaar',
              action: {
                text: 'Update',
                click: function () {
                  if ('serviceWorker' in navigator) {
                    navigator.serviceWorker.getRegistrations().then(function (registrations) {
                      for (let registration of registrations) {
                        registration.update();
                        window.location.reload(true);
                      }
                    })
                  }else{
                    window.location.reload(true);
                  }
                  
                }
              },
              duration: null
            });

            this.toast.show();
          }
        }
      });
    },
    removeCheckUpdate: function(){
      if (this.toast != null) {
        this.toast.destroy();
      }
    },
    startCheckUpdateTimer: function(){
       if (this.update_timer != null) {
         clearInterval(this.update_timer);
       }
      this.update_timer = setInterval(() => {
        if (navigator.onLine) {
          this.checkUpdate();
        } else {
          this.removeCheckUpdate();
        }
      }, 60000);
    },
    toggleOnline: function(online) {
      if (online) {
        document.getElementById('offline').style.display = 'none';
      } else {
        document.getElementById('offline').style.display = 'block';
      }
    },
    startUnsendBadgesTimer: function(){
      if (this.badge_timer != null) {
        clearInterval(this.badge_timer);
      }
      this.badge_timer = setInterval(() => {
        database.readAllData('sync-badges')
          .then(badges => {
            if (badges.length > 0) {
              this.toggleOnline(false);
            } else {
              this.toggleOnline(true);
            }
            this.toggleBadges(badges.length);
          }).catch(() => {
            this.toggleOnline(false);
          });
      }, 10000);
    },
    toggleBadges: function(amount) {
      document.getElementById('badge_count_number').innerHTML = amount;
      if (amount > 0) {
        document.getElementById('badge_count').style.display = 'block';
      } else {
        document.getElementById('badge_count').style.display = 'none';
      }
    },
    startPingTimer: function (kiosk) {
      setInterval(() => {
        if (navigator.onLine) {
          kiosk.ping().catch(() => {});
          kiosk.flush().catch(() => {});
        }
      }, 5 * 60 * 1000);
    },
    onlineChange: function () {
      if (navigator.onLine) {
        this.toggleOnline(true);
        this.checkUpdate();
      } else {
        this.toggleOnline(false);
        this.removeCheckUpdate();
      }
    }
}